import axios from '@/axios.js'

export default {    
  async getOrder({ commit }, params) {
    try {
      const response = await axios.get('sales-and-purchase/kiosk-report', {
        params: params
      })
      if(!params.forDownload){
        commit('SET_ORDER', response.data.data)
      }
      return response.data
    } catch (e) {
      console.log(e)
    }
  },
   async getWarehouseReport({ commit }, params) {
    try {
      const response = await axios.get('sales-and-purchase/kiosk-warehouse-report', {
        params: params
      })
      if(!params.forDownload){
        commit('SET_WAREHOUSE_REPORT', response.data.data)
      }
      return response.data
    } catch (e) {
      console.log(e)
    }
  },
}
